"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var VerifyPaymentCardStrings_1 = __importDefault(require("./VerifyPaymentCardStrings"));
var LIVE_AGENT_PARAMS_URL = 'https://d.la2-c1-ph2.salesforceliveagent.com/chat';
var LIVE_AGENT_PARAMS_DEPLOYMENT_ID = '5721a000000052x';
var LIVE_AGENT_PARAMS_ORG_ID = '00D1a000000KEiH';
var LIVE_AGENT_BUTTON_ID = '5731a00000005i4';
var ContactSupport = /** @class */ (function (_super) {
    __extends(ContactSupport, _super);
    function ContactSupport(props) {
        var _this = _super.call(this, props) || this;
        _this.initChat = function () {
            if (_this.props.consumerId) {
                window.liveagent.addCustomDetail('consumerId', _this.props.consumerId);
                window.liveagent.addCustomDetail('consumerEmail', _this.props.consumerEmail);
                window.liveagent.addCustomDetail('consumerPhoneNumber', _this.props.consumerPhoneNumber);
                window.liveagent.addCustomDetail('orderTotal', _this.props.orderTotal);
                window.liveagent.setName(_this.props.consumerName);
                window.liveagent.init(LIVE_AGENT_PARAMS_URL, LIVE_AGENT_PARAMS_DEPLOYMENT_ID, LIVE_AGENT_PARAMS_ORG_ID);
            }
        };
        _this.startChat = function () {
            _this.props.trackContactSupport(_this.props.orderCartId);
            window.liveagent.startChat(LIVE_AGENT_BUTTON_ID);
        };
        _this.manageConnection = function () {
            if (!window._laq) {
                window._laq = [];
            }
            window._laq.push(function () {
                if (!_this.buttonRef.current) {
                    return;
                }
                window.liveagent.showWhenOnline(LIVE_AGENT_BUTTON_ID, _this.buttonRef.current);
            });
        };
        _this.buttonRef = React.createRef();
        return _this;
    }
    ContactSupport.prototype.componentDidMount = function () {
        if (window.liveagent) {
            this.manageConnection();
            this.initChat();
        }
    };
    ContactSupport.prototype.componentWillUnmount = function () {
        if (window._laq) {
            window.liveagent.disconnect();
        }
        window.liveagent = undefined;
        window.liveAgentDeployment = undefined;
        var availabilityElements = Array.from(document.querySelectorAll('script[src*="handlePing"]'));
        // The salesforce sdk frequently checks for agent availability and
        // adds a script to hand pings. Removing them as well, as a general cleanup.
        if (availabilityElements.length > 0) {
            availabilityElements.forEach(function (element) {
                return document.body.removeChild(element);
            });
        }
    };
    ContactSupport.prototype.render = function () {
        return (React.createElement("span", { id: "contact-support", ref: this.buttonRef, style: { display: 'none' } },
            React.createElement(design_language_1.Text, { display: design_language_1.Text.DisplayModes.Inline, styles: design_language_1.Text.Styles.SectionSubtext }, " " + VerifyPaymentCardStrings_1["default"].or().toLowerCase() + " "),
            React.createElement(component_button_1["default"], { isInline: true, onClick: this.startChat, padding: component_button_1["default"].Padding.None, size: component_button_1["default"].Sizes.Small, type: component_button_1["default"].Types.FlatPrimary }, VerifyPaymentCardStrings_1["default"].contactSupport()),
            React.createElement(design_language_1.Text, { display: design_language_1.Text.DisplayModes.Inline, styles: design_language_1.Text.Styles.SectionSubtext }, " " + VerifyPaymentCardStrings_1["default"].contactSupportSuffixMsg())));
    };
    return ContactSupport;
}(React.Component));
exports["default"] = ContactSupport;
